import UniteFormController from './unites.form.controller';

export default {
    template: require('./unites.form.html'),
    controller: UniteFormController
};
